import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _styled from "@emotion/styled-base";
const _excluded = ["show"];
import React from 'react';
import PropTypes from 'prop-types';
import { Transition, animated } from 'react-spring/renderprops';
import { jsx as ___EmotionJSX } from "@emotion/core";
const transitions = {
  from: {
    opacity: 0
  },
  enter: {
    opacity: 1
  },
  leave: {
    opacity: 0
  }
};
const StyledDiv = /*#__PURE__*/_styled(animated.div, {
  target: "e110s0pp0"
})("background:", _ref => {
  let {
    color
  } = _ref;
  return color;
}, ";position:fixed;top:0;left:0;right:0;bottom:0;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL092ZXJsYXkvT3ZlcmxheS5qc3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV3NDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL092ZXJsYXkvT3ZlcmxheS5qc3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IFRyYW5zaXRpb24sIGFuaW1hdGVkIH0gZnJvbSAncmVhY3Qtc3ByaW5nL3JlbmRlcnByb3BzJztcblxuY29uc3QgdHJhbnNpdGlvbnMgPSB7XG4gIGZyb206IHsgb3BhY2l0eTogMCB9LFxuICBlbnRlcjogeyBvcGFjaXR5OiAxIH0sXG4gIGxlYXZlOiB7IG9wYWNpdHk6IDAgfSxcbn07XG5cbmNvbnN0IFN0eWxlZERpdiA9IHN0eWxlZChhbmltYXRlZC5kaXYpYFxuICBiYWNrZ3JvdW5kOiAkeyh7IGNvbG9yIH0pID0+IGNvbG9yfTtcbiAgcG9zaXRpb246IGZpeGVkO1xuICB0b3A6IDA7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xuICBib3R0b206IDA7XG5gO1xuXG4vKiogQSBjb21wb25lbnQgdGhhdCByZW5kZXJzIGFuIG92ZXJsYXkgb3ZlciB0aGUgZW50aXJlIHZpZXdwb3J0LiAqL1xuY29uc3QgT3ZlcmxheSA9ICh7IHNob3csIC4uLnByb3BzIH0pID0+IChcbiAgPFRyYW5zaXRpb24gbmF0aXZlIGl0ZW1zPXtzaG93fSB7Li4udHJhbnNpdGlvbnN9PlxuICAgIHtkaXNwbGF5ID0+IGRpc3BsYXkgJiYgKHN0eWxlID0+IDxTdHlsZWREaXYgc3R5bGU9e3N0eWxlfSB7Li4ucHJvcHN9IC8+KX1cbiAgPC9UcmFuc2l0aW9uPlxuKTtcblxuT3ZlcmxheS5wcm9wVHlwZXMgPSB7XG4gIC8qKiBUaGUgY29sb3Igb2YgdGhlIG92ZXJsYXkuICovXG4gIGNvbG9yOiBQcm9wVHlwZXMuc3RyaW5nLFxuICAvKiogRHVyYXRpb24gb2YgdGhlIHJldmVhbCBhbmltYXRpb24gaW4gbWlsbGlzZWNvbmRzLiAqL1xuICBkdXJhdGlvbjogUHJvcFR5cGVzLm51bWJlcixcbiAgLyoqIFRoZSBjb2xvciBvZiB0aGUgb3ZlcmxheS4gKi9cbiAgc2hvdzogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5PdmVybGF5LmRlZmF1bHRQcm9wcyA9IHtcbiAgY29sb3I6ICdyZ2JhKDAsMCwwLDAuNSknLFxuICBkdXJhdGlvbjogMzAwLFxuICBzaG93OiBmYWxzZSxcbn07XG5cbmV4cG9ydCB7IE92ZXJsYXkgfTtcbiJdfQ== */"));

/** A component that renders an overlay over the entire viewport. */
const Overlay = _ref2 => {
  let {
      show
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded);
  return ___EmotionJSX(Transition, _extends({
    native: true,
    items: show
  }, transitions), display => display && (style => ___EmotionJSX(StyledDiv, _extends({
    style: style
  }, props))));
};
Overlay.propTypes = {
  /** The color of the overlay. */
  color: PropTypes.string,
  /** Duration of the reveal animation in milliseconds. */
  duration: PropTypes.number,
  /** The color of the overlay. */
  show: PropTypes.bool
};
Overlay.defaultProps = {
  color: 'rgba(0,0,0,0.5)',
  duration: 300,
  show: false
};
export { Overlay };